import { useState, useEffect, useCallback } from 'react';

const useFloatingTimer = () => {
  const [activeTimer, setActiveTimer] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    localStorage.removeItem('activeFloatingTimer');
  }, []);

  // Salvar timer ativo no localStorage
  const saveActiveTimer = useCallback(timerData => {
    if (timerData) {
      localStorage.setItem('activeFloatingTimer', JSON.stringify(timerData));
    } else {
      localStorage.removeItem('activeFloatingTimer');
    }
  }, []);

  // Iniciar timer flutuante
  const startFloatingTimer = useCallback(() => {}, []);

  // Parar timer flutuante
  const stopFloatingTimer = useCallback(() => {
    setActiveTimer(null);
    setIsVisible(false);
    saveActiveTimer(null);
  }, [saveActiveTimer]);

  // Atualizar tempo do timer flutuante
  const updateFloatingTimer = useCallback(
    newTime => {
      if (activeTimer && activeTimer.onTimeUpdate) {
        // Chamar a função de atualização original
        activeTimer.onTimeUpdate(newTime);

        // Atualizar dados do timer local
        const updatedTimer = {
          ...activeTimer,
          task: {
            ...activeTimer.task,
            tracked_seconds: newTime,
          },
        };

        setActiveTimer(updatedTimer);
        saveActiveTimer({
          task: updatedTimer.task,
          startTime: updatedTimer.startTime,
          initialTime: updatedTimer.initialTime,
        });

        console.log('useFloatingTimer: Timer atualizado no localStorage:', newTime);
      }
    },
    [activeTimer, saveActiveTimer],
  );

  // Minimizar/maximizar timer flutuante
  const toggleFloatingTimer = useCallback(() => {
    setIsVisible(prev => !prev);
  }, []);

  return {
    activeTimer,
    isVisible,
    startFloatingTimer,
    stopFloatingTimer,
    updateFloatingTimer,
    toggleFloatingTimer,
  };
};

export default useFloatingTimer;
